<template>
  <div id="teacher_research">
    <div class="over_ta">
      <ul style="margin-top: 20px;">
        <li style="list-style: inside;" v-for="(teacherpublication,index) in teacherpublications" :key="index" v-if="teacherpublication.type === 4">
          <span v-if="teacherpublication.context">
            {{teacherpublication.context}}
          </span> 
          <span v-else>
            <span v-if="executiveDateS(teacherpublication)">{{executiveDateS(teacherpublication)}} ~ {{executiveDateE(teacherpublication)}}, </span> {{showName(teacherpublication)}}, <span v-if="teacherpublication.memo">({{teacherpublication.memo}})</span>
          </span>
        </li>
      </ul>
      <!-- <div class="tea_li" v-for="(teacherpublication,index) in teacherpublications" :key="index" v-if="teacherpublication.type === 4">
        <div class="fix"></div>
        <div class="tea_title"><i class="fa fa-chevron-circle-down mr5" aria-hidden="true"></i>{{showName(teacherpublication)}}</div>
        <div class="tea_tx">
          <table width="100%">
            <tr>
              <td>{{showPage.fundSource}}</td>
              <td>{{showFundSource(teacherpublication)}}</td>
            </tr>
            <tr>
              <td>{{showPage.planNo}}</td>
              <td>{{teacherpublication.planNo}}</td>
            </tr>
            <tr>
              <td>{{showPage.fundBudget}}</td>
              <td>{{teacherpublication.fundBudget}}</td>
            </tr>
            <tr>
              <td>{{showPage.executiveDate}}</td>
              <td>{{executiveDateS(teacherpublication)}} ~ {{executiveDateE(teacherpublication)}}</td>
            </tr>
            <tr>
              <td>{{showPage.memo}}</td>
              <td>{{teacherpublication.memo}}</td>
            </tr>
          </table>
        </div>
      </div> -->
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import { API, Message, ShowPage } from '@/assets/project_setting/config';
import { GetErrorHandler, ShowMessage } from '@/assets/library/axiosErrorHandler';

export default {
  name: 'teacher_research',
  props: ['teacher', 'teacherpublications'],
  data() {
    return {
      info: {},
      showPage: ShowPage(sessionStorage.getItem('locale')),
    };
  },
  created() {},
  methods: {
    executiveDateS(teacherpublication) {
      if (teacherpublication.executiveDateS) {
        let dateArr = teacherpublication.executiveDateS.split(' ')[0].split('-');
        return dateArr[0]
      }
      return ''
    },
    executiveDateE(teacherpublication) {
      if (teacherpublication.executiveDateE) {
        let dateArr = teacherpublication.executiveDateE.split(' ')[0].split('-');
        return dateArr[0]
      }
      return ''
    },
    

    showFundSource(teacherpublication) {
      let show = { CH: teacherpublication.fundSourceCh, EN: teacherpublication.fundSourceEn };
      return show[sessionStorage.locale];
    },
    showName(teacherpublication) {
      let show = { 'CH': teacherpublication.nameCh, 'EN': teacherpublication.nameEn }
      return show[sessionStorage.locale];
    },
  },
}

</script>
<style lang="scss">
#teacher_research {
  table {
    tr {
      td {
        padding: 10px;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// TeacherResearch.vue?21628478